module.exports = __webpack_public_path__ + "static/img/icon.623d95c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon.png
// module id = edSy
// module chunks = 9